(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/correct-result.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/correct-result.js');
"use strict";

const CorrectResult = _ref => {
  let betButtonsToShow = _ref.betButtonsToShow;
  return React.createElement("div", {
    className: "pg_correct_result"
  }, betButtonsToShow.map(result => React.createElement("span", {
    key: result.text
  }, result.text)));
};
setGlobal('svs.components.tipsen.couponStatic.CorrectResult', CorrectResult);

 })(window);